import {Card} from "antd";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import React from "react";


const ExpensesByMonthsGraph = ({dashboardData, formatCurrency}) => {
    return (
        <div style={{marginTop: '20px'}}>
            <Card title="Расходы по месяцам">
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={dashboardData.monthly_expenses}>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="month"/>
                        <YAxis/>
                        <Tooltip
                            formatter={(value) => formatCurrency(value)}
                            labelFormatter={(label) => `Месяц: ${label}`}
                        />
                        <Legend/>
                        <Bar dataKey="salary" name="Зарплата" fill="#52c41a"/>
                        <Bar dataKey="periodic_expenses" name="Периодические" fill="#1890ff"/>
                        <Bar dataKey="one_time_expenses" name="Разовые" fill="#fa8c16"/>
                    </BarChart>
                </ResponsiveContainer>
            </Card>
        </div>

    )
}

export default ExpensesByMonthsGraph;